import React from 'react';
import { Typography } from '@mui/material';
import { getDatePartsFromMilliseconds } from '../../helpers';
import { GetStatisticsResponse } from '../../helpers/api';

export function Statistics(props: Props) {
  const countPlayerBeatOnTime = props.statisticPostData.beatTime;
  const countPlayerBeatOnMoves = props.statisticPostData.beatMoves;
  const playerCount = props.statisticPostData.playerCount;
  const usedMinimum = props.moves === props.minMoves && props.hintsUsed == 0;

  const timePercentile = Math.floor(
    (1 - countPlayerBeatOnTime / playerCount) * 100,
  );
  const movesPercentile = Math.floor(
    (1 - countPlayerBeatOnMoves / playerCount) * 100,
  );

  const winMessage = getWinMessage(
    countPlayerBeatOnTime,
    playerCount,
    usedMinimum,
  );

  const dateParts = getDatePartsFromMilliseconds(props.seconds * 1000);
  const timeString = `${dateParts.hours > 0 ? `${dateParts.hours}h ` : ''}${
    dateParts.minutes
  }m ${dateParts.seconds.toFixed(2)}s`;

  return (
    <div className="statistics">
      <div className="padding-top padding-bottom">
        <table>
          <tbody>
            <tr>
              <th scope="row">Player number</th>
              <td colSpan={2}>{playerCount}</td>
            </tr>
            <tr>
              <th scope="row">{`Moves (min ${props.minMoves})`}</th>
              <td>{props.moves}</td>
              <td>{`top ${movesPercentile}%*`}</td>
            </tr>
            <tr>
              <th scope="row">Time</th>
              <td>{timeString}</td>
              <td>{`top ${timePercentile}%`}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <Typography textAlign={'center'}>{winMessage}</Typography>
      {/* <Typography textAlign={'center'}>
        {`Today's player count: ${playerCount}`}
      </Typography> */}
      <Typography
        textAlign={'center'}
        className="info-text-container padding-top padding-bottom"
      >
        *You are first ranked on hints used, then moves.
      </Typography>
    </div>
  );
}

interface Props {
  seconds: number;
  moves: number;
  minMoves: number;
  hintsUsed: number;
  statisticPostData: GetStatisticsResponse;
}

function getWinMessage(
  countPlayerBeatOnTime: number,
  playerCount: number,
  usedMinimum: boolean,
): string {
  const timePercentile = Math.floor(
    (1 - countPlayerBeatOnTime / playerCount) * 100,
  );

  const bestOnTime = countPlayerBeatOnTime == playerCount - 1;

  if (playerCount < 2) {
    return "The early birdle gets the wormle. You're the first to finish today!";
  }

  //BEST TIME

  if (bestOnTime && usedMinimum) {
    return "A perfect game, and you're today's fastest wormle player so far!";
  }

  if (bestOnTime) {
    return "You're today's fastest wormle player so far!";
  }

  //MIN MOVES
  if (usedMinimum && timePercentile <= 10) {
    return "You're a wormle elite!";
  }

  if (usedMinimum && timePercentile <= 25) {
    return "You're getting good at this!";
  }

  if (usedMinimum && timePercentile == 69) {
    return 'Nice!';
  }

  //SPEED
  if (timePercentile <= 10) {
    return 'You are blazing fast today!';
  }

  return "Not bad, but there's always room for improvement.";
}
